module.exports = __webpack_public_path__ + "static/media/index-popup-small-cattle.70b731ca.gif";